/* ==========================================================================
   Aussie Tonneaus - chatbot engine
   ==========================================================================
   You should not need to edit this file.
     * To change what the bot KNOWS  -> assets/at-chatbot-knowledge.js
     * To change what the bot LOOKS LIKE -> assets/at-chatbot.css
     * To change SETTINGS (colours, email, hours) -> theme editor
     * To rebuild the product index -> tools/build-catalogue.py

   No external dependencies. No cookies. Nothing leaves the browser unless
   the customer chooses to send their question to the team.
   ========================================================================== */

(function () {
  'use strict';

  /* ======================================================================
     0. CONFIG
     ====================================================================== */

  var CFG = window.AT_CHAT_CONFIG || {};
  var D = {
    enabled: true,
    title: 'Aussie Tonneaus Help',
    subtitle: 'Fitment, freight and product questions',
    launcherLabel: 'Need help?',
    showContact: false,         // the "skip the bot" button in the header
    contactLabel: 'Contact us',
    // What the customer calls the assistant. Shown as a sender label above its
    // replies and in the "… is typing" line. Deliberately not a real staff
    // member's name: the footer says "Automated assistant", and borrowing the
    // name of the person who actually answers the email would undercut that.
    botName: 'Tonno',
    showBotName: true,
    footerNote: '',             // strip under the composer; empty = not rendered
    showClear: true,            // "start again" button in the header
    analytics: true,            // push usage events to window.dataLayer (GTM)
    analyticsText: true,        // include the scrubbed question wording
    greeting: 'Hello, and welcome to Aussie Tonneaus.',
    greetingBody: 'I can check what fits your ute, explain freight and returns, or pass ' +
      'your question to our team. What can I help with?',
    email: 'sales@aussietonneaus.com.au',
    phone: '',
    phoneHours: 'from 10am to 12pm, Monday to Friday',
    tradingHours: 'Monday to Friday, 8:00am to 2:00pm',
    sla: '1 business day',
    colourPrimary: '#1b3169',
    colourAccent: '#c4161c',
    answerThreshold: 0.60,
    clarifyThreshold: 0.34,
    contactUrl: '/contact',
    searchUrl: '/search',
    thinkingDelay: 900,  // deliberate pause so replies do not feel like a lookup
                         // table. Set to 0 for batch analysis.
    aiUrl: '',            // set this and the AI fallback switches itself on
    assets: {},
    urls: {},
    pageContext: {},
    debug: false
  };
  for (var k in D) { if (!(k in CFG)) CFG[k] = D[k]; }
  CFG.urls = CFG.urls || {};

  /* Thinking time is a free-text number in the theme editor, so it can arrive
     as a string, as nothing at all, or as 300000 because someone read the field
     as microseconds. Clamp it: a customer should never be left watching a
     spinner indefinitely, and a blank field should mean the default rather
     than zero. */
  var MAX_THINK = 10000;
  CFG.thinkingDelay = (function (v) {
    var n = parseInt(v, 10);
    if (isNaN(n) || n < 0) return D.thinkingDelay;
    return Math.min(n, MAX_THINK);
  })(CFG.thinkingDelay);

  /* The greeting is a special case and must NOT use the full delay.
     Everywhere else the customer has just asked something, so a pause reads as
     consideration. On open they have asked nothing yet, and an empty panel with
     a spinner in it for eight seconds reads as broken software. Cap it. */
  var GREET_CAP = 1200;
  function greetDelay() { return Math.min(CFG.thinkingDelay, GREET_CAP); }

  if (!CFG.enabled) return;

  // Bumped whenever this file changes in a way worth telling apart on a live
  // theme. Read it in the console: AussieChat.build
  var BUILD = '2026-08-13';

  // Mounted inline in a page (the contact page) rather than floating in the
  // corner. Set by goInline() when a [data-at-chat-inline] host is found.
  var INLINE = false;

  /* The suggested-question buttons. On by default, because in the floating
     widget they are most of what gets the conversation started. Switched off
     per host with data-at-chat-starters="off" - the contact page does that,
     where the page around the chat already says what it can answer and the
     buttons were just repeating it. */
  var STARTERS = true;

  var LS_KEY = 'at_chat_v1';
  var MAX_TURNS = 60;

  /* ======================================================================
     1. SMALL UTILITIES
     ====================================================================== */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  function dollars(v) {
    return '$' + (v % 1 === 0 ? Number(v).toFixed(0) : Number(v).toFixed(2));
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function log() {
    if (CFG.debug && window.console) console.log.apply(console, ['[at-chat]'].concat([].slice.call(arguments)));
  }

  /** Replace {{email}}, {{sla}}, {{url.returns}} etc. in an answer. */
  function tokens(str) {
    if (!str) return '';
    return String(str).replace(/\{\{\s*([\w.]+)\s*\}\}/g, function (m, key) {
      if (key.indexOf('url.') === 0) return CFG.urls[key.slice(4)] || '';
      var map = {
        email: CFG.email, phone: CFG.phone, phoneHours: CFG.phoneHours,
        sla: CFG.sla, tradingHours: CFG.tradingHours
      };
      return map[key] != null ? map[key] : '';
    });
  }

  /** Drop <a> tags whose href ended up empty because the URL is not configured. */
  function pruneEmptyLinks(html) {
    return html.replace(/<a\s+href="(?:\s*)"[^>]*>([\s\S]*?)<\/a>/gi, '$1');
  }


  function nowISO() { return new Date().toISOString(); }

  /* ======================================================================
     2. STATE  (localStorage, best effort)
     ====================================================================== */

  var state = {
    messages: [],        // {role:'bot'|'user', html?, text?, ts}
    email: '',
    name: '',
    phone: '',
    vehicle: null,       // last understood vehicle
    family: null,        // last understood product family
    opened: false,
    unread: 0
  };

  function loadState() {
    try {
      var raw = window.localStorage.getItem(LS_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      if (s && typeof s === 'object') {
        for (var p in state) if (p in s) state[p] = s[p];
      }
    } catch (e) { log('state load failed', e); }
  }

  function saveState() {
    try {
      if (state.messages.length > MAX_TURNS) {
        state.messages = state.messages.slice(-MAX_TURNS);
      }
      window.localStorage.setItem(LS_KEY, JSON.stringify(state));
    } catch (e) { /* private browsing - carry on without persistence */ }
  }

  /* ======================================================================
     3. LANGUAGE  - normalising and concept detection
     ====================================================================== */

  var CONTRACTIONS = [
    [/\bwon['’]?t\b/g, 'will not'], [/\bcan['’]?t\b/g, 'cannot'],
    [/\bdon['’]?t\b/g, 'do not'], [/\bdoesn['’]?t\b/g, 'does not'],
    [/\bdidn['’]?t\b/g, 'did not'], [/\bisn['’]?t\b/g, 'is not'],
    [/\baren['’]?t\b/g, 'are not'], [/\bwasn['’]?t\b/g, 'was not'],
    [/\bhaven['’]?t\b/g, 'have not'], [/\bhasn['’]?t\b/g, 'has not'],
    [/\bhadn['’]?t\b/g, 'had not'], [/\bwouldn['’]?t\b/g, 'would not'],
    [/\bshouldn['’]?t\b/g, 'should not'], [/\bcouldn['’]?t\b/g, 'could not'],
    [/\bi['’]?m\b/g, 'i am'], [/\bi['’]?ve\b/g, 'i have'],
    [/\bit['’]?s\b/g, 'it is'], [/\bthat['’]?s\b/g, 'that is'],
    [/\bwhat['’]?s\b/g, 'what is'], [/\bwhere['’]?s\b/g, 'where is'],
    [/\bhow['’]?s\b/g, 'how is'], [/\bi['’]?d\b/g, 'i would'],
    [/\byou['’]?re\b/g, 'you are'], [/\bthere['’]?s\b/g, 'there is'],
    [/\bwhos\b/g, 'who is'], [/\bgday\b/g, 'gday']
  ];

  function normalise(text) {
    var t = ' ' + String(text || '').toLowerCase() + ' ';
    t = t.replace(/[‘’]/g, "'").replace(/[“”]/g, '"');
    for (var i = 0; i < CONTRACTIONS.length; i++) {
      t = t.replace(CONTRACTIONS[i][0], CONTRACTIONS[i][1]);
    }
    t = t.replace(/\$\s*(\d)/g, ' $ $1');
    t = t.replace(/[^a-z0-9$'\-\/\s]/g, ' ');
    t = t.replace(/\s+/g, ' ');
    return t;
  }

  var STOP = {};
  ('a an the is are was were be been being do does did doing have has had having i me my we our you your it its of to in on at for with and or but if so as that this these those there here what which who whom how when why not no yes please thanks thank hi hello just about from would could should can will shall may might must get got').split(' ')
    .forEach(function (w) { STOP[w] = 1; });

  /** Very light stemmer. "returns" -> "return", "shipping" -> "ship". */
  function stem(w) {
    if (w.length < 4) return w;
    if (/(ss|us|is)$/.test(w)) return w;
    if (/ies$/.test(w)) return w.slice(0, -3) + 'y';
    if (/(ches|shes|xes|sses)$/.test(w)) return w.slice(0, -2);
    if (/ing$/.test(w) && w.length > 5) {
      var b = w.slice(0, -3);
      if (b.charAt(b.length - 1) === b.charAt(b.length - 2)) b = b.slice(0, -1);
      return b;
    }
    if (/ed$/.test(w) && w.length > 4) return w.slice(0, -2);
    if (/es$/.test(w) && w.length > 4) return w.slice(0, -1);
    if (/s$/.test(w)) return w.slice(0, -1);
    return w;
  }

  function words(normText) {
    var out = [];
    normText.split(' ').forEach(function (w) {
      if (!w || STOP[w]) return;
      var st = stem(w);
      if (!STOP[st]) out.push(st);
    });
    return out;
  }

  // Phrases that mean "the model on sale right now". Deliberately excludes a
  // bare "new" - see parseVehicle for why.
  var RELATIVE_NOW = /(^| )(current|latest|newest|current model|latest model|new model|current shape|new shape|newest model|current gen|latest gen|new gen|current generation|brand new|this year|current series|latest series)( |$)/;

  var aliasRe = {};

  /**
   * Build a whole-word matcher for one alias.
   * Word boundaries matter more than they look: without them "tonno cover for"
   * matches the alias "no cover for", and a Hilux enquiry gets answered as a
   * custom-build request.
   */
  function aliasMatcher(a) {
    if (aliasRe[a]) return aliasRe[a];
    var body = a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    aliasRe[a] = new RegExp('(^| )' + body + '(s|es|ed|ing)?( |$)');
    return aliasRe[a];
  }

  /** Which concepts does this text contain? Returns a plain object set. */
  function detectConcepts(normText) {
    var C = window.AT_CONCEPTS || {};
    var found = {};
    for (var name in C) {
      var aliases = C[name];
      for (var i = 0; i < aliases.length; i++) {
        var a = aliases[i];
        if (!a) continue;
        if (a === '$') {
          if (normText.indexOf('$') > -1) { found[name] = 1; break; }
        } else if (aliasMatcher(a).test(normText)) {
          found[name] = 1; break;
        }
      }
    }
    return found;
  }

  /** Is a term negated in this text?  "no sports bars", "without a liner" */
  function isNegated(normText, term) {
    var idx = normText.indexOf(term);
    while (idx > -1) {
      var before = normText.slice(Math.max(0, idx - 30), idx);
      if (/\b(no|not|without|dont|do not|havent|have not|arent|are not|never|nope|none|minus|lack|lacking)\b[^.]{0,18}$/.test(before)) {
        return true;
      }
      idx = normText.indexOf(term, idx + 1);
    }
    return false;
  }

  /* ======================================================================
     4. FAQ MATCHER
     ====================================================================== */

  function jaccard(aWords, bWords) {
    if (!aWords.length || !bWords.length) return 0;
    var set = {}, hit = 0, i;
    for (i = 0; i < bWords.length; i++) set[bWords[i]] = 1;
    var seen = {};
    for (i = 0; i < aWords.length; i++) {
      if (set[aWords[i]] && !seen[aWords[i]]) { hit++; seen[aWords[i]] = 1; }
    }
    return hit / Math.max(aWords.length, bWords.length);
  }

  /**
   * How well does one knowledge entry match what the customer typed?
   *
   * The "need" concepts are the discriminator: if they are all present, the
   * customer used the vocabulary of this answer and we are already fairly
   * confident, so satisfied needs earn a solid base score. "want" concepts and
   * text similarity then separate entries that share the same needs.
   *
   * Returns null when the entry is disqualified.
   */
  var BASE = 0.66;      // score once every "need" concept is present
  var WANT_MAX = 0.30;  // extra available from "want" concepts
  var SIM_MAX = 0.20;   // extra available from question similarity
  var PHRASE = 0.25;    // extra for an exact phrase hit

  function scoreEntry(entry, normText, concepts, userWords, ctx) {
    var i;

    // Hard blocks
    if (entry.block) {
      for (i = 0; i < entry.block.length; i++) {
        if (concepts[entry.block[i]]) return null;
      }
    }

    // Hard requirements
    var need = entry.need || [];
    for (i = 0; i < need.length; i++) {
      if (!concepts[need[i]]) return null;
    }

    // Exact phrase hits
    var phraseHit = false;
    if (entry.phr) {
      for (i = 0; i < entry.phr.length; i++) {
        if (normText.indexOf(entry.phr[i]) > -1) { phraseHit = true; break; }
      }
    }
    // Narrow entries only ever fire on their own phrasing, so they cannot
    // hijack every question that happens to mention their product.
    if (entry.phrReq && !phraseHit) return null;

    if (!need.length && !phraseHit) return null;

    // "want" concepts
    var got = 0, ideal = 0;
    var want = entry.want || {};
    for (var c in want) {
      ideal += want[c];
      if (concepts[c]) got += want[c];
    }
    var wantRatio = ideal > 0 ? got / ideal : 0;

    // Similarity against the representative question(s)
    if (!entry._qw) {
      var qs = entry.q ? (typeof entry.q === 'string' ? [entry.q] : entry.q) : [];
      entry._qw = qs.map(function (q) { return words(normalise(q)); });
    }
    var sim = 0;
    for (i = 0; i < entry._qw.length; i++) {
      sim = Math.max(sim, jaccard(userWords, entry._qw[i]));
    }

    var score = BASE + WANT_MAX * wantRatio + SIM_MAX * sim;
    if (phraseHit) score += PHRASE;

    // Product family context, from the page we are on or the conversation
    if (entry.fam && entry.fam.length) {
      if (ctx.family && entry.fam.indexOf(ctx.family) > -1) score += 0.10;
      else if (ctx.family) score -= 0.34;
    }

    // Deterministic tiebreak: a more specific entry beats a broader one.
    score += 0.012 * need.length;

    if (score <= 0) return null;
    return {
      entry: entry, score: Math.min(1, score),
      wantRatio: wantRatio, sim: sim, phrase: phraseHit
    };
  }

  function matchFaq(normText, concepts, ctx) {
    var KB = window.AT_KNOWLEDGE || [];
    var userWords = words(normText);
    var out = [];
    for (var i = 0; i < KB.length; i++) {
      var r = scoreEntry(KB[i], normText, concepts, userWords, ctx);
      if (r) out.push(r);
    }
    out.sort(function (a, b) { return b.score - a.score; });
    return out;
  }

  /* ======================================================================
     5. VEHICLE PARSING  &  FITMENT
     ====================================================================== */

  var CAT = null;   // window.AT_CATALOGUE once loaded

  function famKeyFromConcepts(concepts) {
    var map = [
      ['clampon', 'clampon'], ['clipon', 'clipon'], ['bunji', 'bunji'], ['rope', 'rope'],
      ['ezyfold', 'ezyfold'], ['ezyroll', 'ezyroll'], ['canopy', 'canopy'],
      ['mats', 'mats'], ['traycover', 'tray'], ['trailer', 'trailer'],
      ['accessories', 'accessories']
    ];
    for (var i = 0; i < map.length; i++) {
      if (concepts[map[i][0]]) return map[i][1];
    }
    return null;
  }

  function parseVehicle(normText, concepts) {
    if (!CAT) return null;
    var lex = CAT.lexicon || {};
    var v = { make: null, model: null, cab: null, year: null, flags: {}, raw: normText };

    function hit(dict, field) {
      var best = null;
      for (var canon in dict) {
        var aliases = dict[canon];
        for (var i = 0; i < aliases.length; i++) {
          var a = aliases[i];
          var re = new RegExp('(^| )' + a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '( |$)');
          if (re.test(normText) && (!best || a.length > best.len)) {
            best = { canon: canon, len: a.length };
          }
        }
      }
      if (best) v[field] = best.canon;
    }

    hit(lex.makes || {}, 'make');
    hit(lex.models || {}, 'model');
    hit(lex.cabs || {}, 'cab');

    // If a model was found but no make, infer it. Some model names are shared
    // (Colorado is Holden here but also Chevrolet), so go with whichever make
    // we actually have the most products for.
    if (v.model && !v.make) {
      var mm = lex.makeModels || {};
      var owners = [];
      for (var mk in mm) { if (mm[mk].indexOf(v.model) > -1) owners.push(mk); }
      if (owners.length === 1) {
        v.make = owners[0];
      } else if (owners.length > 1 && CAT.products) {
        var counts = {};
        CAT.products.forEach(function (p) {
          if (p.mo === v.model && p.mk) counts[p.mk] = (counts[p.mk] || 0) + 1;
        });
        var bestMake = null, bestN = 0;
        owners.forEach(function (mk) {
          if ((counts[mk] || 0) > bestN) { bestN = counts[mk]; bestMake = mk; }
        });
        if (bestMake) v.make = bestMake;
      }
    }

    /* A "model" with no products of its own is not a model - it is a variant
       name that lives inside another model's titles. "Raptor" is the live
       example: the lexicon lists it, but every Raptor product is filed under
       Ranger, so asking for a Raptor mat returned "we have nothing for a Ford
       Raptor" while two Raptor products sat in the catalogue.

       Resolve it to the model that actually carries it and keep the word, so
       the Raptor products can be ranked first rather than excluded. Genuine
       gaps - Landcruiser, Tundra - have no products mentioning them either, so
       they are left alone and still answer "nothing listed". */
    if (v.model) {
      var owned = false, k;
      for (k = 0; k < CAT.products.length; k++) {
        if (CAT.products[k].mo === v.model) { owned = true; break; }
      }
      if (!owned) {
        var aliases = (lex.models || {})[v.model] || [];
        var hostCount = {}, hostMake = {}, word = null;
        CAT.products.forEach(function (p2) {
          var t = String(p2.t || '').toLowerCase();
          for (var ai = 0; ai < aliases.length; ai++) {
            if (t.indexOf(aliases[ai]) > -1 && p2.mo) {
              hostCount[p2.mo] = (hostCount[p2.mo] || 0) + 1;
              hostMake[p2.mo] = p2.mk;
              word = word || aliases[ai];
              break;
            }
          }
        });
        var bestHost = null, bestCount = 0;
        for (k in hostCount) { if (hostCount[k] > bestCount) { bestCount = hostCount[k]; bestHost = k; } }
        if (bestHost) {
          v.variant = word;
          v.variantOf = v.model;
          v.model = bestHost;
          if (!v.make) v.make = hostMake[bestHost];
        }
      }
    }

    // Year - a 4 digit year, or a 2 digit one like "'19" / "my 19 ranger"
    var ym = normText.match(/\b(19[6-9]\d|20[0-4]\d)\b/);
    if (ym) {
      v.year = parseInt(ym[1], 10);
    } else {
      var y2 = normText.match(/(?:^| )'?([0-2]\d)(?: |$)/);
      if (y2) {
        var n = parseInt(y2[1], 10);
        v.year = n <= 40 ? 2000 + n : 1900 + n;
      }
    }

    // "current", "latest", "new model" all mean this year's model. Note that a
    // bare "new" must NOT count - "I need a new bunji for my Courier" is a
    // request for a replacement product, not for the current-model Courier.
    if (!v.year && RELATIVE_NOW.test(normText)) {
      v.year = new Date().getFullYear();
      v.yearRelative = true;
    }

    // Series / generation: "PX Ranger", "next gen ranger", "MQ Triton".
    // Only consulted once we know the make or model, because codes this short
    // ("MQ", "TF", "RG") would otherwise fire on ordinary text.
    if (v.make || v.model) {
      var sx = lex.series || {};
      var matched = {}, hitAlias = null, hitLen = 0;
      for (var alias in sx) {
        if (aliasMatcher(alias).test(normText) && alias.length > hitLen) {
          hitAlias = alias; hitLen = alias.length;
        }
      }
      if (hitAlias) {
        sx[hitAlias].forEach(function (sr) { matched[sr] = 1; });
        v.series = Object.keys(matched);
        v.seriesTyped = hitAlias;

        // Naming a generation implies a year window. Use it to rule out
        // products from a different era that carry no series tag of their own -
        // a 1986-2001 Navara is not a D40 no matter how it is tagged.
        var sy = lex.seriesYears || {};
        var lo = null, hi = null;
        v.series.forEach(function (sr) {
          var r = sy[sr];
          if (!r) return;
          lo = lo === null ? r[0] : Math.min(lo, r[0]);
          hi = hi === null ? r[1] : Math.max(hi, r[1]);
        });
        if (lo !== null) v.seriesRange = [lo, hi];

        // Echo the catalogue's own capitalisation ("Next Gen", "PX", "MQ-MR")
        // rather than shouting back whatever the customer typed.
        v.seriesLabel = String(v.series[0]).split('(')[0].trim() || null;
      }
    }

    // Fitment flags
    if (concepts.sportsbar) {
      var neg = isNegated(normText, 'sports bar') || isNegated(normText, 'sportsbar') ||
        isNegated(normText, 'headboard') || isNegated(normText, 'ladder rack');
      if (/head\s?board/.test(normText)) v.flags[neg ? 'noheadboard' : 'headboard'] = 1;
      else v.flags[neg ? 'nosportsbar' : 'sportsbar'] = 1;
      if (concepts.aftermarket) v.flags.aftermarket = 1;
    }
    if (concepts.liner) v.flags.liner = 1;

    // A bare make is enough - we then ask which model they have.
    var hasVehicle = !!(v.model || v.make);
    return hasVehicle ? v : null;
  }

  /* ----------------------------------------------------------------------
     FOLLOW-UPS

     The bot asks "which year is it?" and the customer types "2025". On its own
     that is not a question about anything - no make, no model - so it used to
     fall all the way through to a hand-over. Six of the twenty-odd hand-overs
     in the first week were exactly this: people answering the bot's own
     question and being told to send an email.

     carryVehicle() re-reads the message with the ute we were already talking
     about appended, so parseVehicle's own model and series logic can do its
     work: "it's a np300 2015" becomes "it's a np300 2015 nissan navara", and
     NP300 resolves to a series the way it would have in the first message.

     Year and cab are then taken from THIS message if it supplied them, and
     inherited otherwise, so "dual cab" and "2015" each narrow the same ute
     instead of starting again.

     Deliberately narrow. It only fires when the new message names no vehicle of
     its own - if they switch to a different ute, that wins - and only when the
     message actually adds something. "What is the weather in Perth" adds
     nothing and still hands over.
     ---------------------------------------------------------------------- */
  function carryVehicle(fresh, prev, normText, concepts) {
    if (!prev || !prev.model) return null;
    if (fresh && (fresh.make || fresh.model)) return null;   // they named another ute

    // Lower case: make and model are stored in the catalogue's own
    // capitalisation ("Nissan Navara") but parseVehicle matches lower-case
    // aliases against a normalised string, so appending them as-is matches
    // nothing at all.
    var probe = parseVehicle(
      normText + ' ' + [prev.make, prev.model].filter(Boolean).join(' ').toLowerCase() + ' ',
      concepts);
    if (!probe || !probe.model) return null;

    // probe was parsed from THIS message plus the remembered ute, so anything
    // the customer just typed is already in it. Only fall back to what we
    // remembered where this message was silent.
    probe.year = probe.year || prev.year || null;
    probe.yearRelative = probe.year === prev.year ? prev.yearRelative : probe.yearRelative;
    probe.cab = probe.cab || prev.cab || null;

    // Flags the customer set earlier (factory sports bars, no headboard) still
    // apply to the same ute unless this message overrode them.
    var flags = {}, k;
    for (k in (prev.flags || {})) flags[k] = prev.flags[k];
    for (k in (probe.flags || {})) flags[k] = probe.flags[k];
    probe.flags = flags;

    return probe;
  }

  /** Did this message add anything to a ute we are already discussing?

     Reads the raw text rather than parseVehicle's output, because parseVehicle
     returns null unless it finds a make or model - which is exactly what these
     messages do not have. "2015" on its own parses to nothing at all, and that
     was the whole problem. */
  function addsVehicleDetail(normText, prev) {
    if (!prev || !CAT) return false;
    var lex = CAT.lexicon || {};

    var ym = normText.match(/\b(19[6-9]\d|20[0-4]\d)\b/);
    if (ym && parseInt(ym[1], 10) !== prev.year) return true;

    var cabs = lex.cabs || {}, canon, i, aliases;
    for (canon in cabs) {
      aliases = cabs[canon];
      for (i = 0; i < aliases.length; i++) {
        if (aliasMatcher(aliases[i]).test(normText) && canon !== prev.cab) return true;
      }
    }

    var sx = lex.series || {};
    for (var alias in sx) {
      if (aliasMatcher(alias).test(normText) && alias !== prev.seriesTyped) return true;
    }
    return false;
  }

  function inYear(range, year) {
    if (!range || !year) return null;
    return year >= range[0] && year <= range[1];
  }

  /* ---- products sold by size rather than by vehicle ---------------------- */

  /** Pull a size out of free text: "6x4", "7 x 5", "2400 x 1792". */
  function parseSize(normText) {
    var imp = normText.match(/(\d{1,2})\s*(?:x|by)\s*(\d{1,2})\b/);
    if (imp && +imp[1] <= 30 && +imp[2] <= 30) {
      return { imperial: imp[1] + 'x' + imp[2] };
    }
    var mm = normText.match(/(\d{3,4})\s*(?:x|by)\s*(\d{3,4})\b/);
    if (mm) return { mm: [+mm[1], +mm[2]] };
    return null;
  }

  function findBySize(size, family) {
    if (!CAT || !CAT.products || !size) return [];
    var out = [];
    CAT.products.forEach(function (p) {
      if (family && p.f !== family) return;
      if (!family && !p.ts && !p.d) return;
      var s = 0;
      if (size.imperial && p.ts === size.imperial) s += 8;
      if (size.mm && p.d) {
        var da = Math.abs(p.d[0] - size.mm[0]) + Math.abs(p.d[1] - size.mm[1]);
        if (da === 0) s += 8;
        else if (da <= 120) s += 5;      // close enough to be worth showing
      }
      if (s > 0) out.push({ p: p, s: s });
    });
    out.sort(function (a, b) { return b.s - a.s || a.p.p - b.p.p; });
    return out;
  }

  /** Every size we actually make in a family, smallest first. Read from the
     catalogue rather than written down, so retiring a size updates the answer. */
  function sizesMade(family) {
    if (!CAT || !CAT.products) return [];
    var seen = {};
    CAT.products.forEach(function (p) {
      if (p.f === family && p.ts) seen[p.ts] = 1;
    });
    return Object.keys(seen).sort(function (a, b) {
      var pa = a.split('x'), pb = b.split('x');
      return (+pa[0] - +pb[0]) || (+pa[1] - +pb[1]);
    });
  }

  /** Families chosen by measurement, not by make and model. */
  function isSizeFamily(f) {
    return f === 'trailer' || f === 'tray' || f === 'traycanopy' || f === 'accessories';
  }

  function findByFamily(family, limit) {
    if (!CAT || !CAT.products) return [];
    var out = CAT.products.filter(function (p) { return p.f === family; })
      .map(function (p) { return { p: p, s: 1 }; });
    out.sort(function (a, b) { return a.p.p - b.p.p; });
    return limit ? out.slice(0, limit) : out;
  }

  /**
   * Score one catalogue product against what the customer told us.
   *
   * Cab type, year and factory hardware are treated as HARD incompatibilities,
   * not preferences. Showing a Dual Cab cover to someone with a Space Cab is
   * the single most expensive mistake this widget could make, so anything that
   * contradicts what they told us is excluded outright rather than ranked low.
   *
   * Returns null when the product cannot suit.
   */
  function scoreProduct(p, v, opts) {
    opts = opts || {};
    var family = opts.family;

    if (family) {
      if (opts.strictFamily) { if (p.f !== family) return null; }
    }
    if (p.u && v && v.model) return null;          // universal item, user named a vehicle

    var s = 0;
    var fl = p.fl || [];

    if (v) {
      if (v.model) {
        if (!p.mo || p.mo !== v.model) return null;
        s += 6;
      }

      // They named a variant ("Raptor") that lives in the title rather than in
      // the model field. Rank those first without hiding the rest of the range,
      // since a cab or year filter could otherwise leave them with nothing.
      if (v.variant && String(p.t || '').toLowerCase().indexOf(v.variant) > -1) {
        s += 7;
      }
      if (v.make) {
        if (p.mk && p.mk !== v.make) return null;
        if (p.mk === v.make) s += 3;
      }

      // Cab type - hard requirement when the customer told us theirs.
      if (v.cab && !opts.ignoreCab) {
        if (p.cb && p.cb !== v.cab) return null;
        if (p.cb === v.cab) s += 3;
      } else if (v.cab && p.cb === v.cab) {
        s += 3;
      }

      // Series / generation - hard requirement when the customer named theirs.
      // A product with no series information recorded is not excluded, since we
      // cannot prove it does not suit.
      if (v.series && v.series.length && !opts.ignoreSeries) {
        if (p.sr && p.sr.length) {
          var srHit = false;
          for (var si = 0; si < p.sr.length; si++) {
            if (v.series.indexOf(p.sr[si]) > -1) { srHit = true; break; }
          }
          if (!srHit) return null;
          s += 5;
        } else if (v.seriesRange && p.y && !opts.ignoreSeries) {
          // No series tag on this product, so fall back to the era the named
          // generation belongs to. Ranges must at least overlap.
          if (p.y[1] < v.seriesRange[0] || p.y[0] > v.seriesRange[1]) return null;
          s += 2;
        }
      } else if (v.series && v.series.length && p.sr) {
        s += 2;
      }

      // Year / generation - hard requirement when the customer told us theirs.
      if (v.year && !opts.ignoreYear) {
        var inr = inYear(p.y, v.year);
        if (inr === false) return null;
        if (inr === true) s += 4;
      } else if (v.year && inYear(p.y, v.year) === true) {
        s += 4;
      }

      // Factory sports bars / headboard.
      // Products tagged with BOTH states suit either, so only exclude when the
      // product is explicitly the opposite of what they have.
      var hasSB = fl.indexOf('sportsbar') > -1;
      var hasNSB = fl.indexOf('nosportsbar') > -1;
      if (v.flags.sportsbar) {
        if (hasNSB && !hasSB) return null;
        if (hasSB) s += 4;
      } else if (v.flags.nosportsbar) {
        if (hasSB && !hasNSB) return null;
        if (hasNSB) s += 2;
      }
      if (v.flags.headboard && fl.indexOf('headboard') > -1) s += 3;
    }

    if (family) {
      if (p.f === family) s += 5;
      else s -= 2;
    }

    return s > 0 ? { p: p, s: s } : null;
  }

  function findProducts(v, family, opts) {
    if (!CAT || !CAT.products) return [];
    opts = opts || {};
    opts.family = family;
    var out = [];
    for (var i = 0; i < CAT.products.length; i++) {
      var r = scoreProduct(CAT.products[i], v, opts);
      if (r) out.push(r);
    }
    out.sort(function (a, b) {
      if (b.s !== a.s) return b.s - a.s;
      return a.p.p - b.p.p;
    });
    return out;
  }

  // The order ranges are presented in. Without this, results come out sorted by
  // price, so a general "what fits my Hilux?" leads with a $66 mat instead of a
  // cover - which is not what the customer asked about.
  var FAM_ORDER = ['clipon', 'clampon', 'bunji', 'rope', 'ezyfold', 'ezyroll',
    'canopy', 'traycanopy', 'tray', 'trailer', 'mats', 'accessories'];

  function famRank(f) {
    var i = FAM_ORDER.indexOf(f);
    return i === -1 ? FAM_ORDER.length : i;
  }

  /**
   * Group results so the customer sees one heading per product range.
   * Ranges are ordered by relevance to the question, not by price, and the
   * best-scoring items within each range are kept.
   */
  function groupByFamily(results, limitPerFamily, limitTotal) {
    var byFam = {};
    results.forEach(function (r) {
      var f = r.p.f;
      if (!byFam[f]) byFam[f] = [];
      byFam[f].push(r);
    });

    var fams = Object.keys(byFam).sort(function (a, b) {
      var ra = famRank(a), rb = famRank(b);
      if (ra !== rb) return ra - rb;
      return byFam[b][0].s - byFam[a][0].s;
    });

    var out = [], total = 0;
    for (var i = 0; i < fams.length && total < limitTotal; i++) {
      var take = byFam[fams[i]].slice(0, Math.min(limitPerFamily, limitTotal - total));
      if (!take.length) continue;
      out.push({ family: fams[i], items: take });
      total += take.length;
    }
    return out;
  }

  function famLabel(key) {
    return (CAT && CAT.families && CAT.families[key] && CAT.families[key].label) || key;
  }

  function aOrAn(word) {
    return /^[aeiou]/i.test(String(word || '')) ? 'an' : 'a';
  }

  function vehicleLabel(v) {
    var bits = [];
    if (v.yearRelative) bits.push('current-model');
    else if (v.year) bits.push(v.year);
    if (v.make) bits.push(v.make);
    if (v.seriesLabel) bits.push(v.seriesLabel);
    else if (v.seriesTyped) bits.push(v.seriesTyped.toUpperCase());
    if (v.model) bits.push(v.model);
    // "Ranger Raptor", not just "Ranger" - they asked about a Raptor and the
    // cards say Raptor, so the sentence above them should agree.
    if (v.variant) bits.push(v.variant.charAt(0).toUpperCase() + v.variant.slice(1));
    if (v.cab) bits.push(v.cab);
    var s = bits.join(' ');
    if (v.flags.sportsbar) s += ' (with factory sports bars)';
    else if (v.flags.headboard) s += ' (with factory headboard)';
    return s || 'your vehicle';
  }

  /* ---- live price / availability, so the static index can never mislead ---- */

  /* Three possible states per handle, and the difference matters:

       an object   the product is live on the storefront right now
       GONE        Shopify answered, and said this product is not there:
                   set to Draft or Archived, or unpublished from the Online
                   Store channel. It must not be shown.
       null        we could not ask - offline, blocked, a CDN hiccup. Unknown
                   is not the same as gone, so we still show it using the
                   indexed price rather than showing the customer nothing.

     The old code collapsed GONE and null into null and rendered both from the
     static index, so a product retired after the index was built kept being
     recommended. That is the bug Sam found. */
  var GONE = 'gone';
  var priceCache = {};

  function hydrate(handles) {
    var jobs = handles.filter(function (h) { return !(h in priceCache); }).map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) {
          // 404/410: Shopify knows this handle and says it is not published.
          if (r.status === 404 || r.status === 410) { priceCache[h] = GONE; return null; }
          return r.ok ? r.json() : null;   // 5xx etc: unknown, not gone
        })
        .then(function (j) {
          if (priceCache[h] === GONE) return;
          priceCache[h] = j ? {
            price: j.price, available: j.available,
            compare: j.compare_at_price || 0,
            image: (j.featured_image || (j.images && j.images[0]) || ''),
            title: j.title
          } : null;
        })
        .catch(function () { priceCache[h] = null; });   // network failure: unknown
    });
    return Promise.all(jobs);
  }

  /* Remove anything Shopify has told us is not live, and report how much was
     dropped so the caller can decide whether it still has an answer worth
     giving. Called after hydrate(), never before - before hydrating, every
     handle is simply unknown. */
  function dropRetired(groups) {
    var removed = 0;
    var kept = groups.map(function (g) {
      var items = g.items.filter(function (r) {
        if (priceCache[r.p.h] === GONE) { removed++; return false; }
        return true;
      });
      return { family: g.family, items: items };
    }).filter(function (g) { return g.items.length; });
    if (removed) log('dropped', removed, 'retired product(s) before showing');
    return { groups: kept, removed: removed };
  }

  /* ======================================================================
     6. UI
     ====================================================================== */

  var ui = {};
  var assetsLoading = false, assetsReady = false;

  function loadScript(src) {
    return new Promise(function (res, rej) {
      if (!src) return res();
      var s = document.createElement('script');
      s.src = src; s.async = true;
      s.onload = res; s.onerror = function () { rej(new Error('failed ' + src)); };
      document.head.appendChild(s);
    });
  }

  function ensureAssets() {
    if (assetsReady) return Promise.resolve();
    if (assetsLoading) return assetsLoading;
    var a = CFG.assets || {};
    assetsLoading = Promise.all([
      window.AT_KNOWLEDGE ? Promise.resolve() : loadScript(a.knowledge),
      window.AT_CATALOGUE ? Promise.resolve() : loadScript(a.catalogue)
    ]).then(function () {
      CAT = window.AT_CATALOGUE || null;
      assetsReady = true;
    }).catch(function (e) {
      log('asset load failed', e);
      CAT = window.AT_CATALOGUE || null;
      assetsReady = true;   // degrade to whatever loaded
    });
    return assetsLoading;
  }

  /* Move the widget into an inline host and drop the floating behaviour.
     Returns true if it mounted. Safe to call more than once and safe to call
     with null, so callers do not need to guard.

     Split out of build() because a host can appear after the widget already
     mounted floating - see lateInlineWatch(). */
  function goInline(host) {
    if (INLINE || !host || !ui.root) return false;
    if (host.querySelector('[data-at-chat]')) return false;   // already there

    /* Only ever move a widget that is still part of the live page. A root that
       has been detached belongs to a document that has gone (a test harness
       replacing the page, a theme editor swapping markup), and resurrecting it
       would put a stale second chat on screen. */
    if (!ui.root.isConnected || !host.isConnected) return false;

    // The page's "chat could not load" placeholder, if it has been shown.
    var stale = host.querySelectorAll('[data-at-chat-fallback], .at-cc__fallback');
    for (var i = 0; i < stale.length; i++) stale[i].remove();

    INLINE = true;
    if (host.getAttribute('data-at-chat-starters') === 'off') STARTERS = false;
    ui.root.classList.add('atc--inline', 'atc--open');
    if (ui.launcher) ui.launcher.remove();
    if (ui.closeBtn) ui.closeBtn.remove();
    ui.panel.hidden = false;
    host.appendChild(ui.root);
    return true;
  }

  /* A host that renders after this script still gets the chat. Two real cases:
     a section placed further down the page than the widget's own script, and the
     theme editor replacing a section's markup after you edit it. Without this,
     either one leaves a permanently empty box on the contact page. */
  function lateInlineWatch() {
    var tries = 0;
    function look() {
      if (INLINE) return;
      if (ui.root && !ui.root.isConnected) return;   // this instance is gone
      if (goInline(document.querySelector('[data-at-chat-inline]'))) {
        open();
        return;
      }
      if (++tries < 8) setTimeout(look, 400);
    }
    if (document.readyState === 'complete') setTimeout(look, 0);
    else window.addEventListener('load', look);
    // Shopify fires this when the theme editor re-renders a single section.
    document.addEventListener('shopify:section:load', function () {
      tries = 0;
      look();
    });
  }

  function build() {
    var root = el('div', 'atc');
    root.setAttribute('data-at-chat', '');

    /* ---------------- launcher ---------------- */
    var launcher = el('button', 'atc-launcher');
    launcher.type = 'button';
    launcher.setAttribute('aria-label', 'Open the ' + CFG.title + ' chat');
    launcher.innerHTML =
      '<span class="atc-launcher__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.4 8.4 0 0 1 3.8-.9h.5a8.5 8.5 0 0 1 8 8v.5z"/>' +
      '</svg></span>' +
      '<span class="atc-launcher__text"></span>' +
      '<span class="atc-badge" hidden aria-hidden="true"></span>';
    launcher.querySelector('.atc-launcher__text').textContent = CFG.launcherLabel;
    ui.launcher = launcher;
    ui.badge = launcher.querySelector('.atc-badge');

    /* ---------------- panel ---------------- */
    var panel = el('div', 'atc-panel');
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-label', CFG.title);
    panel.hidden = true;

    var head = el('div', 'atc-head');
    var headText = el('div', 'atc-head__text');
    headText.appendChild(el('p', 'atc-head__title', CFG.title));
    headText.appendChild(el('p', 'atc-head__sub', CFG.subtitle));
    head.appendChild(headText);

    /* An escape hatch from the bot, always visible. Some people simply do not
       want to talk to a robot, and making them prove the bot cannot help first
       is a good way to lose them. This goes straight to the hand-over. */
    var contactBtn = null;
    if (CFG.showContact) {
      contactBtn = el('button', 'atc-head__contact', CFG.contactLabel);
      contactBtn.type = 'button';
      contactBtn.setAttribute('aria-label', CFG.contactLabel + ' — skip the chatbot');
      head.appendChild(contactBtn);
    }

    /* Start again. The transcript survives page loads and page changes, which
       is right for someone mid-enquiry and wrong for someone coming back a week
       later to ask something unrelated. Customers have no console, so the only
       way to clear it has to be a button. */
    var clearBtn = null;
    if (CFG.showClear) {
      clearBtn = el('button', 'atc-icon-btn atc-head__clear');
      clearBtn.type = 'button';
      clearBtn.title = 'Start a new conversation';
      clearBtn.setAttribute('aria-label', 'Clear this conversation and start again');
      clearBtn.innerHTML = '<svg viewBox="0 0 24 24" width="19" height="19" fill="none" ' +
        'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
        'aria-hidden="true"><path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5"/></svg>';
      head.appendChild(clearBtn);
    }

    var closeBtn = el('button', 'atc-icon-btn atc-head__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', 'Close chat');
    closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" ' +
      'stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    head.appendChild(closeBtn);
    panel.appendChild(head);

    var body = el('div', 'atc-body');
    body.setAttribute('role', 'log');
    body.setAttribute('aria-live', 'polite');
    body.setAttribute('aria-relevant', 'additions text');
    panel.appendChild(body);

    var chips = el('div', 'atc-chips');
    panel.appendChild(chips);

    var form = el('form', 'atc-composer');
    form.setAttribute('autocomplete', 'off');
    var input = el('input', 'atc-input');
    input.type = 'text';
    input.placeholder = 'Ask about fitment, freight, returns…';
    input.setAttribute('aria-label', 'Type your question');
    input.setAttribute('maxlength', '400');
    var send = el('button', 'atc-send');
    send.type = 'submit';
    send.setAttribute('aria-label', 'Send');
    send.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<path d="M4 12h15M13 6l6 6-6 6"/></svg>';
    form.appendChild(input);
    form.appendChild(send);
    panel.appendChild(form);

    // The strip under the composer. Empty by default now, so nothing renders
    // and the composer sits on the bottom edge. Put text in "Footer note" in
    // the theme editor to bring it back.
    var footText = String(CFG.footerNote || '').trim();
    if (footText) {
      var foot = el('p', 'atc-foot', footText);
      panel.appendChild(foot);
    }

    root.appendChild(panel);
    root.appendChild(launcher);

    ui.root = root; ui.panel = panel; ui.body = body;
    ui.chips = chips; ui.form = form; ui.input = input;
    ui.closeBtn = closeBtn;   // ui.launcher is already set further up

    /* INLINE MODE
       If the page contains an element with data-at-chat-inline, mount there and
       drop the floating behaviour entirely: no launcher, no fixed positioning,
       always open, no X. That is what makes the contact page work — the chat is
       the page, not something hovering over it.

       If there is no host, mount floating. init() then keeps watching, because a
       host can legitimately turn up later than this script: a section further
       down the page, or the theme editor re-rendering a section after an edit.
       Leaving an empty box on the contact page is the worst of the options. */
    if (!goInline(document.querySelector('[data-at-chat-inline]'))) {
      document.body.appendChild(root);
    }

    launcher.addEventListener('click', toggle);
    closeBtn.addEventListener('click', close);
    if (contactBtn) contactBtn.addEventListener('click', contactTeam);
    if (clearBtn) clearBtn.addEventListener('click', clearChat);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = input.value.trim();
      if (!t) return;
      input.value = '';
      handleUser(t);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !INLINE && !panel.hidden) close();
    });
  }

  function setBadge(n) {
    state.unread = n;
    if (!ui.badge) return;
    if (n > 0) {
      ui.badge.textContent = String(n);
      ui.badge.hidden = false;
      ui.badge.setAttribute('aria-hidden', 'false');
      ui.launcher.setAttribute('aria-label', n + ' new reply in the ' + CFG.title + ' chat');
    } else {
      ui.badge.textContent = '';
      ui.badge.hidden = true;
      ui.badge.setAttribute('aria-hidden', 'true');
      ui.launcher.setAttribute('aria-label', 'Open the ' + CFG.title + ' chat');
    }
  }

  function scrollDown() {
    if (ui.body) ui.body.scrollTop = ui.body.scrollHeight;
  }

  /**
   * Bring a bot reply into view by its TOP, not its bottom.
   *
   * Scrolling to the bottom is right for a chat between two people, where the
   * newest line is the whole message. It is wrong here: a fitment answer runs
   * to several paragraphs and half a dozen product cards, and jumping to the
   * end drops the customer at the last card having never seen the sentence
   * explaining what they are looking at.
   *
   * So: put the top of the reply just below the top of the window and let them
   * read down. If the whole reply already fits, fall back to the bottom, which
   * avoids leaving an odd band of empty space under a one-line answer.
   */
  function scrollToReply(row) {
    if (!ui.body || !row) return;
    var body = ui.body;
    // Wait for layout — images and cards change the height after insertion.
    var apply = function () {
      var pad = 10;
      // Measured with rects, NOT offsetTop. offsetTop is relative to the
      // nearest positioned ancestor, which here is the whole widget rather
      // than the scrolling list, so it silently included the header height and
      // clipped the first line of every long reply. Rects are relative to the
      // viewport, so the difference between them is the true offset inside the
      // scroll container however the CSS is arranged.
      var target = (row.getBoundingClientRect().top -
                    body.getBoundingClientRect().top) + body.scrollTop - pad;
      if (target < 0) target = 0;
      var maxScroll = body.scrollHeight - body.clientHeight;
      // Short reply: nothing to read down to, so behave as before.
      if (target >= maxScroll) { body.scrollTop = maxScroll; return; }
      if (typeof body.scrollTo === 'function') {
        try {
          body.scrollTo({ top: target, behavior: 'smooth' });
          return;
        } catch (e) { /* older browsers: fall through */ }
      }
      body.scrollTop = target;
    };
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(apply);
    } else {
      apply();
    }
  }

  /* ---------------- rendering messages ---------------- */

  function addBubble(role, node) {
    var row = el('div', 'atc-msg atc-msg--' + role);
    var bub = el('div', 'atc-bubble');
    bub.appendChild(node);

    // Name the sender once per reply, not once per bubble. A fitment answer is
    // three or four bubbles and stamping the name on each of them looks like
    // four separate messages.
    var name = role === 'bot' ? botLabel() : '';
    if (name && !replyAnchor) {
      row.classList.add('atc-msg--named');
      var tag = el('span', 'atc-msg__who', name);
      tag.setAttribute('aria-hidden', 'true');   // the log already says who
      row.appendChild(tag);
    }

    row.appendChild(bub);
    ui.body.appendChild(row);
    if (role === 'bot') {
      // A single answer often arrives as several bubbles: the sentence, then
      // the product cards, then a note about narrowing it down. Anchor on the
      // FIRST of them, or the cards would scroll the explanation off the top —
      // which is the same problem as scrolling to the bottom, one step later.
      if (!replyAnchor) replyAnchor = row;
      scrollToReply(replyAnchor);
    } else {
      // The customer's own message goes to the bottom; they know what they
      // just typed. It also opens the anchor for the reply that follows.
      replyAnchor = null;
      scrollDown();
    }
    return row;
  }

  function botHtml(html, opts) {
    opts = opts || {};
    var wrap = el('div', 'atc-rich');
    wrap.innerHTML = pruneEmptyLinks(tokens(html));
    // Force external safety on every link we render
    wrap.querySelectorAll('a').forEach(function (a) {
      if (a.getAttribute('href') && a.getAttribute('href').indexOf('http') === 0) {
        a.setAttribute('rel', 'noopener noreferrer');
        a.setAttribute('target', '_blank');
      }
    });
    var row = addBubble('bot', wrap);
    // Tag every bot message with what produced it. Makes "why did it say that?"
    // answerable by inspecting the element in dev tools.
    row.setAttribute('data-atc-source', opts.source || 'system');
    // Report the FIRST reply of each turn only. A fitment answer is three or
    // four bubbles and counting each would triple the numbers.
    if (opts.source && !turnReported && lastQuestion) {
      turnReported = true;
      trackAnswer(lastQuestion, opts.source);
    }
    if (!opts.silent) {
      state.messages.push({ role: 'bot', html: html, ts: nowISO() });
      saveState();
    }
    return row;
  }

  function userText(text) {
    var p = el('p', null, text);
    addBubble('user', p);
    state.messages.push({ role: 'user', text: text, ts: nowISO() });
    saveState();
  }

  /** The name, if there is one and it is meant to be shown. */
  function botLabel() {
    if (!CFG.showBotName) return '';
    return String(CFG.botName || '').trim();
  }

  function thinkingLabel() {
    var n = botLabel();
    return n ? n + ' is typing…' : 'Thinking…';
  }

  function typing(on) {
    var existing = ui.body.querySelector('.atc-typing');
    if (on) {
      if (existing) return;
      var row = el('div', 'atc-msg atc-msg--bot atc-typing');
      var b = el('div', 'atc-bubble atc-bubble--thinking');
      // Spinner plus a word, rather than bare dots. Dots read as "someone is
      // typing"; a spinner reads as "it is working on it", which is the
      // impression we want while the answer is deliberately held back.
      b.innerHTML =
        '<span class="atc-thinking" role="status" aria-label="Thinking">' +
        '<svg class="atc-spinner" viewBox="0 0 24 24" width="17" height="17" ' +
        'aria-hidden="true" focusable="false">' +
        '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" ' +
        'stroke-width="2.6" stroke-opacity=".22"/>' +
        '<path d="M21 12a9 9 0 0 0-9-9" fill="none" stroke="currentColor" ' +
        'stroke-width="2.6" stroke-linecap="round"/>' +
        '</svg>' +
        '<span class="atc-thinking__text">' + esc(thinkingLabel()) + '</span>' +
        '</span>';
      row.appendChild(b);
      ui.body.appendChild(row);
      scrollDown();
    } else if (existing) {
      existing.remove();
    }
  }

  function setChips(list) {
    ui.chips.innerHTML = '';
    if (!list || !list.length) { ui.chips.hidden = true; return; }
    ui.chips.hidden = false;
    list.slice(0, 4).forEach(function (c) {
      var label = typeof c === 'string' ? c : c.label;
      var b = el('button', 'atc-chip', label);
      b.type = 'button';
      b.addEventListener('click', function () {
        if (typeof c === 'string') {
          handleUser(c);
        } else if (typeof c.action === 'function') {
          var myTurn = newTurn();   // cancels any answer still working in the background
          setChips([]);
          // Clicking a suggestion should feel the same as typing one. Without
          // this, chips answered instantly while typed questions paused, which
          // made the pause look like a bug rather than a considered reply.
          // `instant` opts out for chips that are not answers at all - the
          // mailto button being the only one, where a spinner then a redirect
          // would just be strange.
          if (c.instant || !CFG.thinkingDelay) { c.action(); return; }
          typing(true);
          setTimeout(function () {
            if (stale(myTurn)) return;
            typing(false);
            c.action();
          }, CFG.thinkingDelay);
        }
      });
      ui.chips.appendChild(b);
    });
  }

  /* ---------------- product cards ---------------- */

  function productCard(p) {
    var a = el('a', 'atc-card');
    a.href = '/products/' + p.h;
    var live = priceCache[p.h];

    var thumb = el('span', 'atc-card__thumb');
    if (live && live.image) {
      var img = el('img');
      img.src = live.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
      img.alt = '';
      img.loading = 'lazy';
      img.width = 56; img.height = 56;
      thumb.appendChild(img);
    } else {
      thumb.classList.add('atc-card__thumb--empty');
    }
    a.appendChild(thumb);

    var meta = el('span', 'atc-card__meta');
    meta.appendChild(el('span', 'atc-card__title', p.t));

    var priceLine = el('span', 'atc-card__price');
    if (live && live.price != null) {
      priceLine.textContent = (p.P ? 'From ' : '') + money(live.price);
      if (live.compare && live.compare > live.price) {
        var wasEl = el('s', 'atc-card__was', money(live.compare));
        priceLine.appendChild(document.createTextNode(' '));
        priceLine.appendChild(wasEl);
      }
      if (live.available === false) {
        priceLine.appendChild(el('span', 'atc-card__oos', ' · currently unavailable'));
      }
    } else {
      priceLine.textContent = (p.P ? 'From ' : '') + dollars(p.p);
    }
    meta.appendChild(priceLine);
    a.appendChild(meta);
    return a;
  }

  function renderProducts(groups) {
    var wrap = el('div', 'atc-cards');
    groups.forEach(function (g) {
      var h = el('p', 'atc-cards__head', famLabel(g.family));
      wrap.appendChild(h);
      g.items.forEach(function (r) { wrap.appendChild(productCard(r.p)); });
    });
    addBubble('bot', wrap);
    // Cards are re-derived from the transcript, so store a text summary only.
    var summary = groups.map(function (g) {
      return famLabel(g.family) + ': ' + g.items.map(function (r) {
        return r.p.t + ' (' + dollars(r.p.p) + ')';
      }).join('; ');
    }).join(' | ');
    state.messages.push({ role: 'bot', html: '<p><em>Showed: ' + esc(summary) + '</em></p>', ts: nowISO() });
    saveState();
  }

  /* ======================================================================
     7. CONVERSATION LOGIC
     ====================================================================== */

  var lastAsk = null;   // what we most recently asked the customer for

  /* ----------------------------------------------------------------------
     Turn sequencing.

     Answering can involve async work (loading the catalogue, fetching live
     prices). If the customer types a second question while the first is still
     working, the older handler must not come back and overwrite the newer
     answer's suggestion chips. Each turn takes a number; stale handlers stop.
     ---------------------------------------------------------------------- */
  var turn = 0;
  // The first bot bubble of the current turn. Scroll target for the whole
  // reply, however many bubbles it ends up being.
  var replyAnchor = null;
  // For analytics: what was asked this turn, and whether it has been reported.
  var lastQuestion = '';
  var turnReported = false;
  function newTurn() { return ++turn; }
  function stale(t) { return t !== turn; }

  /**
   * The greeting is rendered fresh every time and NEVER stored in the
   * transcript.
   *
   * It used to be stored like any other message, which meant a returning
   * customer replayed the greeting that was current when they first opened the
   * chat. Change the wording in the theme editor and anyone with an existing
   * conversation in their browser kept seeing the old one — indefinitely, and
   * invisibly, because it looked exactly like the setting had not saved.
   *
   * `silent: true` renders it without persisting it. `replay()` calls greet()
   * itself, so returning customers always get today's wording.
   */
  function greet() {
    botHtml('<p><strong>' + esc(CFG.greeting) + '</strong></p>' +
      '<p>' + esc(CFG.greetingBody) + '</p>',
      { source: 'greeting', silent: true });
    setChips(defaultChips());
  }

  /**
   * The buttons offered when the chat opens.
   *
   * Deliberately fitment-first. Returns and warranty used to sit here, which
   * put "what happens when this goes wrong" in front of someone who has not
   * bought anything yet. They are still answered on request; they are just not
   * the opening suggestion.
   *
   * If the customer is standing on a product or collection page, the first chip
   * uses that context instead of asking a generic question.
   */
  function defaultChips() {
    /* Off on the contact page. Returning nothing here rather than skipping the
       one call in greet() is deliberate: every other caller is also a "back to
       the opening suggestions" moment - after a hand-over, on "ask something
       else", when an answer has no follow-ups of its own - and they should all
       stay quiet too. An answer's OWN chips are unaffected; those are part of a
       conversation the customer started, not an unprompted menu. */
    if (!STARTERS) return [];

    var fam = (CFG.pageContext && CFG.pageContext.family) || '';
    var chips = [{ label: 'Will this fit my ute?', action: startFitmentFlow }];

    if (fam && famLabel(fam)) {
      chips.push({
        label: 'Tell me about the ' + famLabel(fam),
        action: function () { answerFamily(fam, newTurn()); }
      });
    } else {
      chips.push('Which cover should I get?');
    }

    chips.push('How much is freight?');
    chips.push('How long will delivery take?');
    return chips;
  }

  /* ======================================================================
     THE SITE'S OWN VEHICLE SELECTOR
     ----------------------------------------------------------------------
     The theme already has a "Find Your Fit" modal (snippets/modal-filter.liquid
     driven by assets/filter.js) that walks the customer through Make → Model →
     Body → Year → Sports Bars. Two things follow from that, and both are worth
     more than anything the chat could build itself:

       1. If they have already used it, the site stored their choice in the
          `arn-filter` cookie. The bot should know their ute without asking.
       2. If they have not, the bot should hand them the selector rather than
          make them type a vehicle into a chat box.

     The theme exposes an `open-filter-modal` event on document and lazy-loads
     the filter script if it is not there yet, so opening it is one line and
     needs no coupling to its internals.
     ====================================================================== */

  /** Read the site's vehicle selector cookie, if the customer has used it. */
  function vehicleFromSite() {
    var raw = '';
    try {
      var m = document.cookie.match(/(?:^|;\s*)arn-filter=([^;]*)/);
      raw = m ? decodeURIComponent(m[1]) : '';
    } catch (e) { return null; }
    if (!raw) return null;

    // The cookie is usually a JSON object keyed by the selector's own labels,
    // but one path in the theme writes a plain title string instead. Handle
    // both rather than assuming.
    var text = raw;
    if (raw.charAt(0) === '{') {
      try {
        var obj = JSON.parse(raw);
        text = ['Make', 'Model', 'Body', 'Year', 'Sports Bars']
          .map(function (k) { return obj[k] || ''; })
          .filter(Boolean).join(' ');
      } catch (e) { text = raw; }
    }
    text = String(text).replace(/\s+/g, ' ').trim();
    if (text.length < 3) return null;

    // Run it through the bot's own parser rather than trusting the labels, so
    // a selector value the catalogue does not recognise is simply ignored.
    var norm = normalise(text);
    var v = parseVehicle(norm, detectConcepts(norm));
    return (v && v.model) ? v : null;
  }

  /** Open the theme's "Find Your Fit" modal. */
  function openSiteSelector() {
    try {
      document.dispatchEvent(new CustomEvent('open-filter-modal'));
      return true;
    } catch (e) {
      log('could not open the site vehicle selector', e && e.message);
      return false;
    }
  }

  /** Is the selector actually present on this page? */
  function hasSiteSelector() {
    return !!(document.getElementById('modal-filter-template') ||
      document.querySelector('.modal-ui[data-url]') ||
      window.Filter);
  }

  /**
   * "Will this fit my ute?" — the most-clicked button, and until now the one
   * that failed. It reached the FAQ matcher as a bare question with no vehicle
   * in it, matched nothing, and handed the customer to email. Being asked to
   * send an email by the button labelled "will this fit my ute" is the worst
   * possible first impression of a fitment tool that indexes 570 products.
   *
   * It now starts the vehicle conversation instead, and uses the page the
   * customer is standing on when there is one.
   */
  function startFitmentFlow() {
    var myTurn = newTurn();
    var fam = (CFG.pageContext && CFG.pageContext.family) || '';
    var famName = fam ? famLabel(fam) : '';
    if (fam) { state.family = fam; saveState(); }

    /* Best case: they have already told the site what they drive, so asking
       again would be the chat ignoring something the website plainly knows. */
    var known = state.vehicle && state.vehicle.model ? state.vehicle : vehicleFromSite();
    if (known && known.model) {
      state.vehicle = known;
      saveState();
      botHtml('<p>I can see you are shopping for a <strong>' +
        esc(vehicleLabel(known)) + '</strong> — here is what we make for it.</p>',
        { source: 'fitment-ask' });
      return answerFitment(known, fam || null, {}, !!fam, myTurn);
    }

    botHtml('<p>Happy to check.' + (famName
      ? ' I can see you are looking at our <strong>' + esc(famName) + '</strong> range.'
      : '') + '</p>' +
      '<p>What are you driving? <strong>Make, model, cab type and year</strong> is ' +
      'ideal, but a make and model is enough to start — for example ' +
      '<em>2019 Hilux dual cab</em>, or <em>next gen Ranger</em>.</p>',
      { source: 'fitment-ask' });

    var chips = [];
    // The site's own selector walks them through every field and is better at
    // this than a chat box, so offer it first where it exists.
    if (hasSiteSelector()) {
      chips.push({
        label: 'Use the vehicle selector',
        instant: true,
        action: function () {
          if (!openSiteSelector()) {
            botHtml('<p>I could not open the selector just now — type your make ' +
              'and model here instead and I will find it.</p>', { source: 'fitment-ask' });
          }
        }
      });
    }
    // ...and the makes we actually build for, so someone unsure what to type
    // can just tap.
    topMakes(hasSiteSelector() ? 4 : 6).forEach(function (m) {
      chips.push({ label: m, action: function () { handleUser(m); } });
    });

    setChips(chips);
    if (ui.input) ui.input.focus();
    return myTurn;
  }

  /** The makes with the most products, for the tap-to-start chips. */
  function topMakes(n) {
    if (!CAT || !CAT.products) return ['Ford', 'Toyota', 'Isuzu', 'Mitsubishi'];
    var tally = {};
    CAT.products.forEach(function (p) { if (p.mk) tally[p.mk] = (tally[p.mk] || 0) + 1; });
    return Object.keys(tally)
      .sort(function (a, b) { return tally[b] - tally[a]; })
      .slice(0, n || 6);
  }

  /* ======================================================================
     ANALYTICS
     ----------------------------------------------------------------------
     Pushed to `window.dataLayer`, which Google Tag Manager already puts on
     every page of this store (GTM-MDLXJCR). Nothing new to host, nothing to
     pay for, and the numbers land somewhere the shop already looks.

     Three events:
       at_chat_opened    someone opened the chat        -> how often it is used
       at_chat_answered  a question got an answer       -> what it is answering
       at_chat_handover  it could not answer            -> the work queue

     WHAT IS AND IS NOT SENT
     The answer id and the outcome are always safe. The customer's own words
     are not: people paste order numbers, phone numbers and email addresses
     into chat windows without thinking, and Google's terms prohibit sending
     personal data to Analytics. So question text is scrubbed of anything that
     looks identifying before it leaves, and can be switched off entirely with
     the "Send question wording" setting.
     ====================================================================== */

  var SCRUB = [
    [/[^\s<>@]+@[^\s<>@]+\.[^\s<>@]+/g, '[email]'],
    /* Australian phone numbers, most specific shape first. The naive
       "four digits then four digits" pattern missed the commonest one of all:
       a mobile is 04XX XXX XXX, which is 4-3-3, and a loose pattern then
       matched the TAIL of it and left "041" sitting in the string. */
    [/(\+?61[\s-]?)?\(?0?4\)?[\s-]?\d{2}[\s-]?\d{3}[\s-]?\d{3}\b/g, '[phone]'],  // mobile
    [/\b1[38]00[\s-]?\d{3}[\s-]?\d{3}\b/g, '[phone]'],                            // 1300 / 1800
    [/\b13[\s-]?\d{2}[\s-]?\d{2}\b/g, '[phone]'],                                 // 13 xx xx
    [/(\+?61[\s-]?)?\(?0?[2378]\)?[\s-]?\d{4}[\s-]?\d{4}\b/g, '[phone]'],        // landline
    [/\b\d{5,}\b/g, '[number]'],          // order and tracking numbers
    [/\b\d{1,4}[a-z]?\s+[A-Z][a-z]+\s+(St|Street|Rd|Road|Ave|Avenue|Dr|Drive|Ct|Crt|Cres|Pl|Way|Lane|Ln)\b/g, '[address]']
  ];

  function scrub(text) {
    var t = String(text || '');
    SCRUB.forEach(function (r) { t = t.replace(r[0], r[1]); });
    return t.replace(/\s+/g, ' ').trim().slice(0, 200);
  }

  function track(event, data) {
    if (!CFG.analytics) return;
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: event, chat_page: window.location.pathname };
      for (var k in data) { if (data.hasOwnProperty(k)) payload[k] = data[k]; }
      window.dataLayer.push(payload);
      log('tracked', event, payload);
    } catch (e) { /* analytics must never break the chat */ }
  }

  /* Which sources mean "a human is still needed". Kept here rather than in the
     caller so the definition cannot drift between the widget and the reports. */
  var UNANSWERED = { escalate: 1, 'escalate-email': 1, none: 1,
    'fitment-none': 1, 'family-unknown': 1, 'contact-us': 1 };

  function trackAnswer(question, source) {
    var handed = !!UNANSWERED[source];
    track(handed ? 'at_chat_handover' : 'at_chat_answered', {
      chat_answer: source || 'none',
      chat_question: CFG.analyticsText ? scrub(question) : '(not sent)',
      chat_answered: !handed
    });
  }

  function handleUser(text) {
    // Inline, this is the first moment we know a person is using the chat
    // rather than merely loading the page it sits on. No-op after the first.
    reportOpened();

    lastQuestion = text;
    turnReported = false;
    userText(text);
    setChips([]);

    // If we asked them to type out their question for the team, this is it.
    if (lastAsk === 'question') {
      lastAsk = null;
      return captureQuestion(text);
    }
    lastAsk = null;

    var myTurn = newTurn();
    typing(true);
    ensureAssets().then(function () {
      // small deliberate pause so it does not feel like a lookup table
      return new Promise(function (r) { setTimeout(r, CFG.thinkingDelay); });
    }).then(function () {
      if (stale(myTurn)) return;
      typing(false);
      respond(text, myTurn);
    });
  }

  function respond(text, myTurn) {
    var normText = normalise(text);
    var concepts = detectConcepts(normText);

    /* If the customer has used the site's own vehicle selector, adopt that as
       the working vehicle before answering anything. Done here rather than at
       boot because the catalogue loads lazily and parseVehicle needs it.
       Only ever fills a gap — anything they have said in the chat wins. */
    if (!state.vehicle || !state.vehicle.model) {
      var fromSite = vehicleFromSite();
      if (fromSite) {
        state.vehicle = fromSite;
        saveState();
        log('vehicle adopted from the site selector', vehicleLabel(fromSite));
      }
    }

    log('concepts', Object.keys(concepts));

    /* ---- social niceties ---- */
    if (concepts.greet && Object.keys(concepts).length <= 2 && normText.length < 30) {
      botHtml('<p>Hello. What can I help you with?</p>', { source: 'greet' });
      setChips(defaultChips());
      return;
    }
    if (concepts.thanks && Object.keys(concepts).length <= 2) {
      botHtml('<p>No worries at all. Anything else I can check for you?</p>', { source: 'thanks' });
      setChips(defaultChips());
      return;
    }
    if (concepts.bye && Object.keys(concepts).length <= 2) {
      botHtml('<p>Good on you. If anything else comes up, just open this chat again — ' +
        'your conversation will still be here.</p>', { source: 'bye' });
      return;
    }

    /* ---- negation: "I have NO sports bars" is not a sports bar question ---- */
    var negatedBars = false;
    if (concepts.sportsbar &&
        (isNegated(normText, 'sports bar') || isNegated(normText, 'sportsbar') ||
         isNegated(normText, 'headboard') || isNegated(normText, 'ladder rack'))) {
      negatedBars = true;
      delete concepts.sportsbar;
    }

    /* ---- context ---- */
    var family = famKeyFromConcepts(concepts) ||
      (CFG.pageContext && CFG.pageContext.family) || state.family;
    var vehicle = parseVehicle(normText, negatedBars ? { sportsbar: 1 } : concepts) || null;
    if (vehicle && negatedBars) { vehicle.flags.nosportsbar = 1; delete vehicle.flags.sportsbar; }
    if (vehicle) state.vehicle = vehicle;
    if (famKeyFromConcepts(concepts)) state.family = famKeyFromConcepts(concepts);
    saveState();

    var ctx = { family: family, vehicle: vehicle || state.vehicle };

    /* ---- FAQ ---- */
    var faq = matchFaq(normText, concepts, ctx);
    var top = faq[0] || null;
    var second = faq[1] || null;

    log('faq', top && top.entry.id, top && top.score.toFixed(2),
      second && second.entry.id, second && second.score.toFixed(2));

    var famNamed = famKeyFromConcepts(concepts);
    var explicitFitment = concepts.fit || concepts.fitmentguarantee ||
      /\b(do you (make|have|do|sell)|got anything|looking for|show me|whats available|what is available|options for|suit my|need a|want a|after a)\b/.test(normText);

    // "How much is a bunji for a Colorado" is a product question, not a
    // freight question - unless they actually said a shipping word.
    var productPriceQ = concepts.cost && !concepts.shipping;

    // A FAQ answer counts as strong if it scored well or matched an exact
    // phrase from the knowledge base.
    //
    // An entry can opt out with yieldToFitment. That exists for one case:
    // "see attached photo, will this suit my 2016 Navara D23". Both readings
    // are right, but the customer named a vehicle, and showing them what fits
    // it beats telling them only that a human will look at the picture. The
    // photo answer still reaches everyone who attached one without saying
    // what they drive, which is the large majority of them.
    var strongFaq = top && (top.score >= 0.78 || top.phrase) &&
      !top.entry.yieldToFitment;

    var wordCount = normText.trim().split(' ').length;

    /* A confident FAQ answer wins, unless the customer named a vehicle AND
       clearly wanted products. Naming a product family alongside a vehicle
       ("bunji for me courier") counts as wanting products. */
    var vehicleFirst = vehicle && vehicle.model && !strongFaq &&
      (explicitFitment || productPriceQ || !!famNamed);

    if (top && top.score >= CFG.answerThreshold && !vehicleFirst) {
      // Two answers this close together means the question was genuinely
      // ambiguous. Better to ask than to pick the wrong one.
      if (second && second.score >= CFG.answerThreshold &&
          (top.score - second.score) < 0.03 &&
          top.entry.topic !== second.entry.topic) {
        return offerChoice([top, second], ctx, vehicle, text);
      }
      answerFaq(top.entry, ctx, vehicle);
      return;
    }

    /* ---- a follow-up about the ute we are already discussing ----
       Runs after the FAQ branch, so a real question still wins, and before the
       fitment branch, which needs a model in THIS message. */
    if ((!vehicle || !vehicle.model) && state.messages.length) {
      var carried = null;

      /* Only for messages that are an ANSWER, not a question. If the FAQ
         matcher showed any interest at all, this is a question with a real
         answer behind it and must not be turned into a product list - "does the
         canopy come with a mattress" mentions a range but is not a follow-up
         about their ute. A bare correction like "it is a clip on cover" is kept
         short, for the same reason. */
      var faqInterest = top && top.score >= CFG.clarifyThreshold;

      /* A correction names a range and states something: "No, not the bunji -
         it is a clip on cover". A QUESTION that happens to mention a range is a
         different animal: "can you tow my trailer up to brisbane" is not a
         follow-up about their ute, and treating it as one loses the customer's
         actual question. An opening interrogative is the giveaway. */
      var asksSomething = /^(can|could|do|does|did|will|would|should|is|are|was|were|have|has|how|what|where|why|who|when|which)\b/
        .test(normText.trim());
      var namedRange = famNamed && !vehicle && wordCount <= 14 && !asksSomething;

      /* A long question is never a fragment, even when a series alias happens
         to appear inside it. "Can you tow my trailer up to brisbane for me next
         week" contains "next", which is a Ranger generation, and that was
         enough to turn a towing question into a product list. Short questions
         are still allowed through - "what about 2015?" really is a follow-up. */
      var addsDetail = addsVehicleDetail(normText, state.vehicle) &&
        (!asksSomething || wordCount <= 6);

      if (!faqInterest && (addsDetail || namedRange)) {
        carried = carryVehicle(vehicle, state.vehicle, normText, concepts);
      }
      if (carried && carried.model) {
        state.vehicle = carried;
        saveState();
        /* A follow-up stays in the range they were asking about. They said
           "canopy for a navara" and then "2015"; showing them bunjis and mats
           as well would be answering a question they did not ask. This is the
           one place a remembered family SHOULD restrict the results, which is
           why strictFamily is set from it. */
        var followFamily = famNamed || state.family || family || null;
        return answerFitment(carried, followFamily, concepts, !!followFamily, myTurn);
      }
    }

    /* ---- sold-by-size products: trailers, trays ---- */
    var size = parseSize(normText);
    if (size && (isSizeFamily(family) || !family)) {
      var sizeFam = isSizeFamily(family) ? family : null;
      var sized = findBySize(size, sizeFam);
      if (sized.length) {
        botHtml('<p>Here is what we make in that size:</p>', { source: 'fitment-size' });
        hydrateAndShow(sized, { flags: {} }, false, family, null, myTurn);
        return;
      }

      /* They gave us a size we do not make. "I need one cover for trailer 10x6"
         used to hand over with no explanation, which reads as the bot failing
         rather than as an answer. Telling them the sizes that DO exist is the
         useful reply, and the list is read from the catalogue so it cannot go
         stale. */
      if (size.imperial && sizeFam) {
        var made = sizesMade(sizeFam);
        if (made.length) {
          botHtml('<p>We do not make a <strong>' + esc(size.imperial.replace('x', ' x ')) +
            '</strong> one, sorry. The sizes we do are <strong>' +
            esc(made.join(', ').replace(/x/g, ' x ')) + '</strong>.</p>' +
            '<p>If none of those suit, the team can tell you what your options are.</p>',
            { source: 'fitment-none' });
          // skipApology: we just gave them a real answer. Following it with
          // "I cannot answer that one" would contradict the line above it.
          offerEscalation('Do you have a ' + size.imperial + ' ' + famLabel(sizeFam) + '?', true);
          return;
        }
      }
    }

    /* ---- fitment ----
       Naming a vehicle is not on its own a product enquiry. "What is the towing
       capacity of a Ranger?" mentions a Ranger but is not something we can
       answer, so it needs to reach a human rather than get a product list. */
    var productIntent = explicitFitment || productPriceQ || !!famNamed ||
      concepts.fit || concepts.tonneau || concepts.mats || concepts.trailer ||
      concepts.traycover || concepts.accessories || concepts.vehicle ||
      wordCount <= 5;

    if (vehicle && vehicle.model && productIntent) {
      // Only restrict to one range when they named it in this message. A family
      // inherited from the page they are on should not hide other options.
      return answerFitment(vehicle, family, concepts, !!famNamed, myTurn);
    }

    /* ---- make named but no model: offer the models we cover ---- */
    if (vehicle && vehicle.make && !vehicle.model && productIntent) {
      return answerMakeOnly(vehicle, family);
    }

    /* ---- family named but no vehicle: overview + ask for the ute ----
       Only when they are actually browsing. "Does the canopy come with a
       mattress?" mentions a canopy but is not a request for the range.

       The family has to come from THIS message, or from the page they are
       standing on. It must not be inherited from earlier in the conversation.
       `family` above falls back to state.family, and that fallback was answering
       questions it had no business answering: once someone had asked about clip
       ons, "do you sell tyres" and "what is the weather in Perth tomorrow" both
       produced a clip-on range overview. Two costs to that. The customer is told
       something irrelevant instead of being pointed at a human, and the question
       is logged as chat_answered when it belongs in chat_handover - so the report
       of what the bot cannot do looks shorter than it really is.

       The 197-case harness could not see this, because it cleared state.family
       between questions. Real conversations do not. */
    var overviewFamily = famNamed || (CFG.pageContext && CFG.pageContext.family) || null;
    var browsing = productPriceQ || explicitFitment || concepts.what ||
      concepts.help || concepts.stock || wordCount <= 4;
    if (overviewFamily && !vehicle && browsing) {
      return answerFamily(overviewFamily, myTurn);
    }

    /* ---- ambiguous: offer the closest few ---- */
    if (top && top.score >= CFG.clarifyThreshold) {
      var opts = faq.filter(function (r) { return r.score >= CFG.clarifyThreshold; }).slice(0, 3);
      if (opts.length > 1) return offerChoice(opts, ctx, vehicle, text);
      answerFaq(top.entry, ctx, vehicle);
      return;
    }

    /* ---- no idea ---- */
    offerEscalation(text);
  }

  function firstQ(entry) {
    return typeof entry.q === 'string' ? entry.q : (entry.q && entry.q[0]) || 'This one';
  }

  function offerChoice(opts, ctx, vehicle, originalText) {
    botHtml('<p>I want to make sure I answer the right thing. Which of these are you after?</p>',
      { source: 'clarify' });
    setChips(opts.slice(0, 3).map(function (r) {
      return {
        label: firstQ(r.entry),
        action: function () { userText(firstQ(r.entry)); answerFaq(r.entry, ctx, vehicle); }
      };
    }).concat([{
      label: 'None of these',
      action: function () { offerEscalation(originalText); }
    }]));
  }

  function answerFaq(entry, ctx, vehicle) {
    var html = entry.a;
    botHtml(html, { source: entry.id });

    if (entry.links && entry.links.length) {
      var wrap = el('div', 'atc-links');
      var any = false;
      entry.links.forEach(function (l) {
        var url = tokens(l.url);
        if (!url) return;
        any = true;
        var a = el('a', 'atc-linkbtn', l.label);
        a.href = url;
        wrap.appendChild(a);
      });
      if (any) addBubble('bot', wrap);
    }

    var chips = (entry.chips || []).slice();
    if (vehicle && vehicle.model) {
      chips.unshift({
        label: 'Show what fits my ' + (vehicle.make ? vehicle.make + ' ' : '') + vehicle.model,
        action: function () { answerFitment(vehicle, null, {}); }
      });
    }
    if (entry.escalate === true) {
      chips.unshift({ label: 'Send this to the team', action: function () { offerEscalation(entry.q, true); } });
    } else if (entry.escalate === 'soft') {
      chips.push({ label: 'Ask the team about this', action: function () { offerEscalation(entry.q, true); } });
    }
    setChips(chips.length ? chips : defaultChips());
  }

  function answerFitment(v, family, concepts, strictFamily, myTurn) {
    if (myTurn == null) myTurn = turn;
    if (!CAT) {
      botHtml('<p>I could not load our product list just now. You can search the site ' +
        'directly, or I can send your question to the team.</p>', { source: 'fitment-nocat' });
      setChips([{
        label: 'Send this to the team',
        action: function () { offerEscalation('Fitment question'); }
      }]);
      return;
    }

    var results = findProducts(v, family, { strictFamily: strictFamily });
    var loosened = null;

    // Nothing in the range they named? Widen to the whole catalogue first.
    if (!results.length && family) {
      results = findProducts(v, null);
      family = null;
    }

    // Still nothing. Relax what they told us, one detail at a time, and be
    // explicit about which detail we ignored so they can check it themselves.
    if (!results.length && v.year) {
      results = findProducts(v, family, { strictFamily: strictFamily, ignoreYear: true });
      if (results.length) loosened = v.yearRelative ? 'model year' : 'year';
    }
    if (!results.length && v.series) {
      results = findProducts(v, family,
        { strictFamily: strictFamily, ignoreYear: true, ignoreSeries: true });
      if (results.length) loosened = 'series and year';
    }
    if (!results.length && v.cab) {
      results = findProducts(v, family,
        { strictFamily: strictFamily, ignoreYear: true, ignoreSeries: true, ignoreCab: true });
      if (results.length) loosened = 'cab type, series and year';
    }

    if (!results.length) {
      botHtml('<p>I could not find anything listed for ' + aOrAn(v.year || v.make || v.model) +
        ' <strong>' + esc(vehicleLabel(v)) + '</strong>.</p>' +
        '<p>That usually means we do not have a pattern for that exact configuration — but it ' +
        'is worth having our team confirm, because they can sometimes adapt an existing ' +
        'pattern.</p>', { source: 'fitment-none' });
      setChips([
        {
          label: 'Ask the team about my ute',
          action: function () { offerEscalation('Fitment for ' + vehicleLabel(v)); }
        },
        {
          label: 'Search the site',
          action: function () {
            window.location.href = CFG.searchUrl + '?q=' +
              encodeURIComponent([v.make, v.model].filter(Boolean).join(' ')) + '&type=product';
          }
        }
      ]);
      return;
    }

    /* Describe exactly what is about to appear below, so the numbers in the
       sentence always match the cards.

       This is why the sentence is a FUNCTION rather than a string, and why it is
       written after hydration rather than before. Retired products are dropped
       once Shopify has been asked, and a headline written beforehand said "we
       make 2 canopies" above a single card. Counting first and checking second
       is how you end up lying to the customer in your own summary line. */
    var groups = groupByFamily(results, family ? 6 : 2, 8);
    var allFams = {};
    results.forEach(function (r) { allFams[r.p.f] = 1; });
    var famCount = Object.keys(allFams).length;

    var label = esc(vehicleLabel(v));
    var article = aOrAn(v.year || v.make || v.model);

    function intro(total, shown) {
      if (loosened) {
        return '<p>I could not find an exact match for ' + article + ' <strong>' + label +
          '</strong>, so I have set the <strong>' + loosened + '</strong> aside. Please check ' +
          'these against your ute carefully before ordering — or let our team confirm it for ' +
          'you.</p>';
      }
      /* Name a range only when the results really are limited to it. `family`
         can be inherited from earlier in the conversation while the results
         deliberately are not restricted, and then this sentence announced
         "18 Wildback Soft Ute Canopies" above a list led by clip on covers.
         strictFamily is the flag that says the restriction was actually
         applied. */
      if (family && strictFamily) {
        var fname = esc(famLabel(family));
        return '<p>Yes — we make <strong>' + total + '</strong> ' +
          (total === 1 ? fname : plural(fname)) + ' to suit ' + article + ' <strong>' + label +
          '</strong>' + (shown < total ? '. Here are ' + shown + ' of them' : '') + ':</p>';
      }
      return '<p>Good news — we make <strong>' + total + ' product' +
        (total === 1 ? '' : 's') + '</strong> across <strong>' + famCount +
        ' range' + (famCount === 1 ? '' : 's') + '</strong> to suit ' + article + ' <strong>' +
        label + '</strong>' + (shown < total ? '. Here is a pick of them' : '') + ':</p>';
    }

    hydrateAndShow(results, v, !!loosened, family, groups, myTurn, {
      intro: intro,
      source: loosened ? 'fitment-relaxed' : 'fitment'
    });
  }

  /* "Canopy" -> "Canopies", not "Canopys". Consonant + y is the only English
     rule worth encoding here; everything else in the catalogue takes a plain s. */
  function plural(word) {
    return /[^aeiou]y$/i.test(word) ? word.replace(/y$/i, 'ies') : word + 's';
  }

  function hydrateAndShow(results, v, relaxed, family, preGrouped, myTurn, headline) {
    if (myTurn == null) myTurn = turn;
    var groups = preGrouped || groupByFamily(results, family ? 6 : 2, 8);
    var handles = [];
    groups.forEach(function (g) { g.items.forEach(function (r) { handles.push(r.p.h); }); });

    hydrate(handles).then(function () {
      if (stale(myTurn)) return;

      /* Anything retired since the index was built is dropped here rather than
         shown with an indexed price. If that empties the answer, say so and
         hand over - recommending nothing is better than recommending something
         they cannot buy, and a fitment question with no live product is exactly
         the kind of thing a person should look at. */
      var live = dropRetired(groups);
      if (!live.groups.length) {
        botHtml('<p>I had matches for <strong>' + esc(vehicleLabel(v)) + '</strong>, but they ' +
          'are not available on the site at the moment.</p>' +
          '<p>The team can tell you what has replaced them.</p>',
          { source: 'fitment-none' });
        offerEscalation('What suits a ' + vehicleLabel(v) + '?');
        return;
      }
      groups = live.groups;

      // Every count below this line is a LIVE count. results.length still
      // includes anything Shopify has retired, so using it here would put the
      // same wrong number back in a different sentence.
      var liveShown = 0;
      groups.forEach(function (g) { liveShown += g.items.length; });
      var liveTotal = Math.max(results.length - live.removed, liveShown);

      /* The headline is written HERE, after the retired products are gone, so
         "we make 2 canopies" can never sit above one card. `removed` only counts
         products we actually asked about, which is every one we were going to
         show - so when the whole match set fits on screen the number is exact,
         and when it does not the sentence already says "here are 6 of them". */
      if (headline && headline.intro) {
        botHtml(headline.intro(liveTotal, liveShown), { source: headline.source });
      }

      renderProducts(groups);

      var notes = [];
      if (!v.cab) notes.push('cab type');
      if (!v.year || v.yearRelative) notes.push('year');
      if (notes.length && liveTotal > 3 && !relaxed) {
        botHtml('<p class="atc-note">Tell me the ' + notes.join(' and ') +
          ' and I can narrow that down to the exact one.</p>');
      }
      if (v.flags.aftermarket) {
        botHtml('<p class="atc-note"><strong>Note:</strong> we only make covers to suit ' +
          '<em>factory</em> sports bars and headboards, not aftermarket bars or ladder racks.</p>');
      }

      var chips = [];
      if (liveTotal > 8) {
        chips.push({
          label: 'See all ' + liveTotal + ' on the site',
          action: function () {
            window.location.href = CFG.searchUrl + '?q=' +
              encodeURIComponent([v.make, v.model, v.cab].filter(Boolean).join(' ')) + '&type=product';
          }
        });
      }
      chips.push('Which cover should I get?');
      chips.push('How much is freight?');
      chips.push({ label: 'Not quite right — ask the team', action: function () { offerEscalation('Fitment for ' + vehicleLabel(v)); } });
      setChips(chips);
    });
  }

  function answerMakeOnly(v, family) {
    var mm = (CAT && CAT.lexicon && CAT.lexicon.makeModels) || {};
    var models = mm[v.make] || [];
    if (!models.length) {
      botHtml('<p>Tell me the model as well and I will check what we make for it.</p>');
      return;
    }
    botHtml('<p>We cover quite a few <strong>' + esc(v.make) + '</strong> models. Which one is ' +
      'yours?</p>', { source: 'make-only' });
    setChips(models.slice(0, 4).map(function (m) {
      return {
        label: v.make + ' ' + m,
        action: function () {
          userText(v.make + ' ' + m);
          answerFitment({ make: v.make, model: m, cab: v.cab, year: v.year, flags: v.flags }, family, {});
        }
      };
    }));
    if (models.length > 4) {
      botHtml('<p class="atc-note">Also: ' + esc(models.slice(4).join(', ')) +
        '. Just type yours.</p>');
    }
  }

  function answerFamily(famKey, myTurn) {
    if (myTurn == null) myTurn = turn;
    var f = CAT && CAT.families && CAT.families[famKey];
    if (!f) {
      botHtml('<p>Which vehicle is it for? Make, model, cab type and year is ideal.</p>',
        { source: 'family-unknown' });
      return;
    }

    // Trailers, trays and accessories are not chosen by vehicle, so asking for
    // a make and model would be nonsense. Show the range instead.
    if (isSizeFamily(famKey)) {
      var items = findByFamily(famKey, 6);
      botHtml('<p>Our <strong>' + esc(f.label) + '</strong> range starts at <strong>' +
        dollars(f.min) + '</strong>. These are sized to your ' +
        (famKey === 'trailer' ? 'trailer' : famKey === 'accessories' ? 'setup' : 'tray') +
        ', not to a vehicle:</p>', { source: 'family-overview' });
      var handles = items.map(function (r) { return r.p.h; });
      hydrate(handles).then(function () {
        if (stale(myTurn)) return;
        var live = dropRetired(groupByFamily(items, 6, 6));
        if (!live.groups.length) {
          botHtml('<p>That range is not showing anything available right now. ' +
            'The team can tell you where it is up to.</p>', { source: 'family-unknown' });
          offerEscalation('Availability in the ' + f.label + ' range');
          return;
        }
        renderProducts(live.groups);
        botHtml('<p class="atc-note">Measure the outside edges where the cover attaches — ' +
          'length and width — and tell me the numbers if you are not sure which to pick.</p>',
          { source: 'family-note' });
        setChips(['How do I measure my tray?', 'How much is freight?',
          { label: 'Ask the team', action: function () { offerEscalation('Sizing question'); } }]);
      });
      return;
    }

    botHtml('<p>Our <strong>' + esc(f.label) + '</strong> range: <strong>' + f.n +
      ' fitments</strong> from <strong>' + dollars(f.min) + '</strong>' +
      (f.max > f.min ? ' to <strong>' + dollars(f.max) + '</strong>' : '') + '.</p>' +
      '<p>Tell me your make, model, cab type and year and I will show you the exact one for ' +
      'your vehicle.</p>', { source: 'family-overview' });
    var chips = (f.makes || []).slice(0, 3).map(function (mk) { return mk; });
    chips.push('Which cover should I get?');
    setChips(chips);
  }

  /* ======================================================================
     8. ESCALATION  ->  Shopify's own contact form
     ====================================================================== */

  var pendingQuestion = '';

  /* ----------------------------------------------------------------------
     Optional AI fallback.

     This only ever runs for questions the local knowledge base could NOT
     answer, which is the whole point: the common questions stay instant and
     free, and Claude is only paid for on the hard ones. Leave aiUrl blank in
     the theme editor and none of this executes.
     ---------------------------------------------------------------------- */

  function askAi(question) {
    if (!CFG.aiUrl) return Promise.resolve(null);
    typing(true);
    var payload = {
      question: question,
      transcript: transcript().slice(-4000),
      vehicle: state.vehicle || null,
      family: state.family || null,
      page: window.location.href
    };
    var done = false;
    var timeout = new Promise(function (res) {
      setTimeout(function () { if (!done) res(null); }, 12000);
    });
    var call = fetch(CFG.aiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });

    return Promise.race([call, timeout]).then(function (j) {
      done = true;
      typing(false);
      return j;
    });
  }

  /** Render the AI's plain-text answer as paragraphs, never as HTML. */
  function renderAiAnswer(text, sources) {
    var wrap = el('div', 'atc-rich');
    String(text).split(/\n{2,}/).forEach(function (para) {
      var t = para.trim();
      if (t) wrap.appendChild(el('p', null, t));
    });
    if (sources && sources.length) {
      var note = el('p', 'atc-note');
      note.textContent = 'Based on: ' + sources.join(', ');
      wrap.appendChild(note);
    }
    var row = addBubble('bot', wrap);
    row.setAttribute('data-atc-source', 'ai');
    state.messages.push({
      role: 'bot',
      html: '<p>' + esc(String(text).replace(/\n{2,}/g, '</p><p>')) + '</p>',
      ts: nowISO()
    });
    saveState();
  }

  function offerEscalation(question, skipApology) {
    // Give the AI a go before troubling a human.
    if (CFG.aiUrl && !offerEscalation._tried) {
      offerEscalation._tried = true;
      var aiTurn = turn;
      return askAi(question).then(function (j) {
        offerEscalation._tried = false;
        if (stale(aiTurn)) return;
        if (j && j.confident && j.answer) {
          renderAiAnswer(j.answer, j.sources);
          setChips([
            'Ask something else',
            {
              label: 'That did not help — ask the team',
              action: function () { offerEscalationDirect(question, true); }
            }
          ]);
          return;
        }
        offerEscalationDirect(question, skipApology);
      });
    }
    return offerEscalationDirect(question, skipApology);
  }

  function offerEscalationDirect(question, skipApology) {
    pendingQuestion = question || '';
    if (!skipApology) {
      botHtml('<p><strong>I cannot answer that one</strong>, and I would rather ' +
        'not guess at it.</p>', { source: 'escalate' });
    }
    handOver();
  }

  /**
   * Point the customer at the mailbox and get out of the way.
   *
   * This used to collect an email address, mint a reference number and POST it
   * to Shopify's contact form in the background. All of that was machinery
   * around a simple job, and on this store the POST silently failed for days
   * while telling everyone it had worked.
   *
   * What is left is the whole job: say we cannot answer, name the address, and
   * offer a link that opens their mail app with the question already in it. If
   * the link does nothing, the address is right there in the text to copy.
   */
  function handOver() {
    var q = String(pendingQuestion || '').trim();
    var vehicle = state.vehicle ? vehicleLabel(state.vehicle) : '';

    botHtml('<p>Send it to <strong>' + esc(CFG.email) + '</strong> and the team ' +
      'will come back to you within <strong>' + esc(CFG.sla) + '</strong>.</p>' +
      '<p><a href="' + esc(mailtoFor(q, vehicle)) + '">Email us about this</a></p>',
      { source: 'escalate-email' });

    setChips([
      { label: 'Email us', instant: true,
        action: function () { window.location.href = mailtoFor(q, vehicle); } },
      'Ask something else'
    ]);
    pendingQuestion = '';
  }

  /* Pre-fill what we already know so the customer is not retyping it, and keep
     the whole URL well short of the ~2000 characters at which mail clients
     start dropping mailto links on the floor. */
  function mailtoFor(question, vehicle) {
    var q = question.slice(0, 400);
    var body = q ? 'My question: ' + q + '\n\n' : '';
    if (vehicle) body += 'My vehicle: ' + vehicle + '\n\n';
    body += 'Sent from the help chat on ' + window.location.href;

    var subject = q
      ? q.replace(/\s+/g, ' ').slice(0, 70)
      : 'Website enquiry';

    return 'mailto:' + CFG.email +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(body);
  }


  /**
   * Wipe the conversation and greet again, as if they had just arrived.
   * Behind the circular-arrow button in the header.
   */
  function clearChat() {
    newTurn();
    typing(false);
    pendingQuestion = '';
    lastAsk = null;
    replyAnchor = null;
    state.messages = [];
    state.vehicle = null;
    state.family = null;
    saveState();
    ui.body.innerHTML = '';
    setChips([]);
    greet();
    if (ui.input) { ui.input.value = ''; ui.input.focus(); }
  }

  /* The optional "Contact us" button in the header. Deliberately does NOT run
     the question through the knowledge base first - the customer has decided
     they want a person. */
  function contactTeam() {
    newTurn();
    typing(false);
    pendingQuestion = '';
    lastAsk = null;
    botHtml('<p>No problem — our team is at <strong>' + esc(CFG.email) +
      '</strong> and replies within <strong>' + esc(CFG.sla) + '</strong>.</p>' +
      '<p>What would you like to ask them? If it is about fitment, include your ' +
      '<strong>make, model, cab type and year</strong> and I will put it in the ' +
      'email for you.</p>',
      { source: 'contact-us' });
    lastAsk = 'question';
    setChips([{
      label: 'Actually, let me ask the bot first',
      action: function () {
        lastAsk = null;
        botHtml('<p>Sure — what would you like to know?</p>', { source: 'contact-cancelled' });
        setChips(defaultChips());
      }
    }]);
    if (ui.input) ui.input.focus();
  }

  /* They typed their question out for the team rather than asking the bot. */
  function captureQuestion(text) {
    pendingQuestion = text;
    handOver();
  }

  /* ======================================================================
     9. OPEN / CLOSE
     ====================================================================== */

  /* "Opened" has to mean a person chose to start a conversation, or the number
     is worthless. In the floating widget that is the launcher click, so open()
     reports it. Inline on the contact page there is no launcher - the chat opens
     itself on page load - so reporting it here would count every visit to the
     page as a use of the chatbot and quietly inflate the figure. Inline, the
     event is held back until the customer actually asks something: see
     reportOpened() in handleUser(). */
  var openedReported = false;

  function reportOpened() {
    if (openedReported) return;
    openedReported = true;
    track('at_chat_opened', { chat_returning: !!state.opened });
  }

  function open() {
    ui.panel.hidden = false;
    ui.root.classList.add('atc--open');
    ui.launcher.setAttribute('aria-expanded', 'true');
    setBadge(0);
    if (!INLINE) reportOpened();

    if (!state.opened) {
      state.opened = true;
      saveState();
      typing(true);
      ensureAssets().then(function () {
        setTimeout(function () { typing(false); greet(); }, greetDelay());
      });
    } else if (!ui.body.childElementCount) {
      ensureAssets().then(function () {
        // replay() now renders the greeting itself, so an empty transcript and
        // a full one both start with today's wording.
        replay();
        setChips(defaultChips());
      });
    }
    setTimeout(function () { if (ui.input) ui.input.focus(); }, 120);
  }

  function replay() {
    // Today's greeting, then the stored conversation. The greeting is not in
    // state.messages precisely so that editing it in the theme editor reaches
    // customers who already have a conversation open.
    botHtml('<p><strong>' + esc(CFG.greeting) + '</strong></p>' +
      '<p>' + esc(CFG.greetingBody) + '</p>',
      { source: 'greeting', silent: true });
    state.messages.forEach(function (m) {
      if (m.role === 'user') {
        addBubble('user', el('p', null, m.text || ''));
      } else {
        var w = el('div', 'atc-rich');
        w.innerHTML = pruneEmptyLinks(tokens(m.html || ''));
        addBubble('bot', w);
      }
    });
    scrollDown();
  }

  function close() {
    if (INLINE) return;          // nothing to close: the chat IS the page
    ui.panel.hidden = true;
    ui.root.classList.remove('atc--open');
    ui.launcher.setAttribute('aria-expanded', 'false');
    ui.launcher.focus();
  }

  function toggle() { if (ui.panel.hidden) open(); else close(); }

  /* ======================================================================
     10. GO
     ====================================================================== */

  function init() {
    if (document.querySelector('[data-at-chat]')) return;  // already mounted
    loadState();
    build();
    ui.launcher.setAttribute('aria-expanded', 'false');
    setBadge(state.unread || 0);

    // Public hooks so other parts of the theme (or the AI upgrade) can drive it.
    window.AussieChat = {
      open: open,
      close: close,
      ask: function (q) { open(); setTimeout(function () { handleUser(q); }, 350); },
      reset: function () {
        try { window.localStorage.removeItem(LS_KEY); } catch (e) { }
        state.messages = []; state.opened = false;
        state.vehicle = null; state.family = null;
        if (ui.body) ui.body.innerHTML = '';
      },
      state: state,
      debug: function () { CFG.debug = true; },

      /* Diagnostics. `inline` answers "did it mount in the page or float?", and
         `build` proves which copy of this file the theme is serving - the fast
         way to catch a stale asset upload, which looks exactly like a broken
         chat. */
      build: BUILD,
      supportsInline: true,
      get inline() { return INLINE; },
      mountInline: function (host) {
        if (goInline(host || document.querySelector('[data-at-chat-inline]'))) {
          open();
          return true;
        }
        return false;
      }
    };

    // Inline: no launcher to click, so start the conversation straight away.
    if (INLINE) {
      open();
    } else {
      lateInlineWatch();
      if (/[?&]at_chat=open/.test(window.location.search)) setTimeout(open, 600);
    }
  }

  /* ----------------------------------------------------------------------
     Test hook. Used by tools/test-questions.js to exercise the matcher
     headlessly. Inert in a normal browser session.
     ---------------------------------------------------------------------- */
  if (typeof window.AT_CHAT_TEST_HOOK === 'function') {
    window.AT_CHAT_TEST_HOOK({
      normalise: normalise,
      detectConcepts: detectConcepts,
      matchFaq: matchFaq,
      parseVehicle: parseVehicle,
      findProducts: findProducts,
      famKeyFromConcepts: famKeyFromConcepts,
      handleUser: handleUser,
      setCatalogue: function (c) { CAT = c; },
      cfg: CFG,
      state: state
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();